export default "__VITE_ASSET__CKnPgd9V__"